import mainBanner from '@/assets/img/banner/publication.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import PublicationSubmissionGuide from '@/components/Publication/PublicationSubmissionGuide/PublicationSubmissionGuide';

const Submission = () => {
	return (
		<main>
			<SubBanner subTitle="publication.page.bannerSubtitle" title="publication.page.menu.submission" img={mainBanner} />
			<PublicationSubmissionGuide />
		</main>
	);
};

export default Submission;
